import { Injectable } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class SidenavService {
    private sidenav: MatDrawer;
    private sidenavBehaviorSubject: BehaviorSubject<MatDrawer>;
    private sidenavObservable: Observable<MatDrawer>;

    constructor() {
        this.sidenav = null;

        this.sidenavBehaviorSubject = new BehaviorSubject<MatDrawer>(null);
        this.sidenavObservable = this.sidenavBehaviorSubject.asObservable();
    }

    public setSidenav(sidenav: MatDrawer) {
        this.sidenav = sidenav;

        this.sidenavBehaviorSubject.next(sidenav);
    }

    public getSidenav(): MatDrawer {
        return this.sidenav;
    }

    getSidenavObservable(): Observable<MatDrawer> {
        return this.sidenavObservable;
    }

    public open() {
        if (this.sidenav != null) {
            return this.sidenav.open();
        }
    }

    public close() {
        if (this.sidenav != null) {
            return this.sidenav.close();
        }
    }

    public toggle(): void {
        if (this.sidenav != null) {
            this.sidenav.toggle();
        }
    }

    // public subscribe(observer): void {
    //     this.sidenav.openedChange.subscribe(observer);
    // }
}